import { render, staticRenderFns } from "./service-price.vue?vue&type=template&id=b0b86622&"
import script from "./service-price.vue?vue&type=script&lang=js&"
export * from "./service-price.vue?vue&type=script&lang=js&"
import style0 from "./service-price.vue?vue&type=style&index=0&id=b0b86622&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports